import { render, staticRenderFns } from "./cardRotacion.vue?vue&type=template&id=3d9a50e5&scoped=true&"
import script from "./cardRotacion.vue?vue&type=script&lang=js&"
export * from "./cardRotacion.vue?vue&type=script&lang=js&"
import style0 from "./cardRotacion.vue?vue&type=style&index=0&id=3d9a50e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9a50e5",
  null
  
)

export default component.exports